import { postJson } from '../../http'

export default {
    // 获取列表
    fetchMsgList (data) {
        return postJson('/lz/sitemsg/setting/list', data)
    },

    // 查询用户加入组织列表
    findUserJoinCompanyServiceList (data) {
        return postJson('/lz/sitemsg/setting/findUserJoinCompanyServiceList', data)
    },

    // 保存设置
    messageSettingSave (data) {
        return postJson('/lz/sitemsg/setting/save', data)
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/main/message.js